import { Component, Input } from '@angular/core';
import { hasValue } from '@util';

import { NavItem } from './nav-item';

@Component({
  selector: 'pcs-nav-link-item',
  templateUrl: './nav-link-item.component.html',
  styleUrls: ['./nav-link-item.component.scss']
})
export class NavLinkItemComponent {
  @Input() link: NavItem;

  get badgeClass() {
    return {
      'blue-badge': Number(this.link.badge) > 0
    };
  }

  get path() {
    return this.link.path;
  }

  hasLabel() {
    return hasValue(this.link.label);
  }
}
